import { request, downloadRequest } from '@/utils/request'

/* 司機資料 */

// get
export const reqList = (task, filter, auth) =>
  request.get(
    `driver/list?task=${task}${filter ? '&filter=' + filter : ''}${
      auth ? '&auth=' + auth : ''
    }`,
  )

export const reqDriverAuditList = () => request.get(`driverInfo/license`)

// post
export const reqDownloadDriver = () =>
  downloadRequest.post(`excel/driver_data-excel`)

export const reqSuspensionMsgToDriver = (payload) =>
  request.post(`socket/attention`, payload)



// WEBPACK FOOTER //
// ./src/api/driverList/index.js